/* unplugin-vue-components disabled */import { render } from "./entrance.vue?vue&type=template&id=591d1662&scoped=true"
import script from "./entrance.vue?vue&type=script&lang=js"
export * from "./entrance.vue?vue&type=script&lang=js"

import "./entrance.vue?vue&type=style&index=0&id=591d1662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591d1662"]])

export default __exports__